import type { NavKey, PageTestSource, RunPhase } from "@/lib/qa-types";

interface TestPipelineStripProps {
    active: NavKey;
    source: PageTestSource | null;
    caseCount: number;
    runPhase: RunPhase;
    hasReport: boolean;
    onNavigate: (target: NavKey) => void;
}

const stages: { key: NavKey; index: string; label: string }[] = [
    { key: "browser", index: "01", label: "质量探索" },
    { key: "generate", index: "02", label: "场景生成" },
    { key: "runs", index: "03", label: "任务执行" },
    { key: "overview", index: "04", label: "质量总览" },
];

export function TestPipelineStrip({ active, source, caseCount, runPhase, hasReport, onNavigate }: TestPipelineStripProps) {
    const completed = {
        browser: Boolean(source),
        generate: caseCount > 0,
        runs: runPhase === "passed",
        overview: hasReport,
    };
    return (
        <div className="test-pipeline-strip" aria-label="页面测试流水线">
            <div className="pipeline-source">
                <span>TEST FLOW</span>
                <strong>{source?.title ?? "从被测页面开始"}</strong>
                <small>{source?.target_url ?? "输入 URL 和测试需求，逐步完成质量闭环"}</small>
            </div>
            <div className="pipeline-stages">
                {stages.map((stage) => {
                    const done = completed[stage.key as keyof typeof completed];
                    return (
                        <button
                            aria-label={`流水线阶段 ${stage.index}`}
                            className={`${active === stage.key ? "active" : ""} ${done ? "done" : ""}`}
                            key={stage.key}
                            onClick={() => onNavigate(stage.key)}
                            type="button"
                        >
                            <b>{done ? "✓" : stage.index}</b>
                            <span>{stage.label}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
